import React from 'react'
import { Header , Footer , Container } from '../components/index'

function Home() {
  return (
    <>
                <Header />
                <Container/>
                <Footer/>

    </>
  )
}

export default Home